var _defs, _circle, _circle2, _circle3, _circle4, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFixed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 18.665,
    cy: 21.26,
    r: 0.73
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 24.356,
    cy: 21.26,
    r: 0.73
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 30.048,
    cy: 21.26,
    r: 0.73
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 36.479,
    cy: 28.667,
    r: 1.445
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M11.381 8.786a3.84 3.84 0 10-7.68 0v3.215h7.638l.042-3.215zM11.338 12.001v25.634h25.141v-4.33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M7.815 4.945h24.824a3.84 3.84 0 013.84 3.84v14.904"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixed);
export default __webpack_public_path__ + "static/media/Fixed.370e5ae7a9c723a0d98241b229dc81f4.svg";
export { ForwardRef as ReactComponent };